export default "__VITE_ASSET__woqpMeU4__"